import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { UserInfo } from "../types";
import { useDataFormatter } from "./useDataFormatter";
import { fetchEntityProfileInfo } from "../api/entity";
import { useTranslation } from "react-i18next";

export const useProfileData = () => {
  const [shouldRefetch, setShouldRefetch] = useState(false);
  const { i18n } = useTranslation();
  const {
    data: userData,
    isLoading,
    isError,
    refetch,
  } = useQuery<UserInfo>({
    queryKey: ["userInfo", i18n.language],
    queryFn: async () => {
      const result = await fetchEntityProfileInfo();
      return result;
    },
    enabled: shouldRefetch,
  });

  const {
    fullName,
    firstTwoChr,
    about,
    countryName,
    countryMedia,
    media,
    mediaFileName,
    role,
    profileViewers,
    verificationStatus,
    posts,
    followersCount,
    followingCount,
    id,
    entityId,
    entityLevel,
    isVerified,
    email,
  } = useDataFormatter(userData);

  const data = {
    fullName,
    firstTwoChr,
    about,
    countryName,
    countryMedia,
    media,
    mediaFileName,
    role,
    profileViewers,
    verificationStatus,
    posts,
    followersCount,
    followingCount,
    id,
    entityId,
    entityLevel,
    isVerified,
    email,
  };

  useEffect(() => {
    if (!userData && !isLoading && !isError) {
      setShouldRefetch(true);
    }
  }, [userData, isLoading, isError]);

  return { data, isLoading, isError, refetch };
};
